import { useName } from '@morningtrain/react-resources'
import endsWith from 'lodash/endsWith'

export default function useFieldName (baseName = null) {
  const name = useName(baseName, { type: 'as' })
  const parts = name.split('.')

  let newName = parts.shift()

  if (parts.length > 0) {
    newName = newName + '[' + parts.join('][') + ']'
  }

  if (endsWith(baseName, '[]')) {
    newName = newName + '[]'
  }

  return newName
}
